import { openCardAnywhere } from '../lib/openCard';
import type { router as Router } from '../routes';
import { completeFromShade } from './notifications';

/**
 * hmawiw:// addresses from outside the app: the widget and the icon shortcut open quick add with
 * the card sorted later; a notification opens its card on its own board, marks it done from the
 * shade, or opens the check-in.
 */
function handle(url: string | undefined, router: typeof Router): void {
  if (!url) return;
  const m = /^hmawiw:\/\/(add|card|done|checkin)(?:\/([^/?#]+))?/.exec(url);
  if (!m) return;
  const id = m[2] ? decodeURIComponent(m[2]) : null;
  if (m[1] === 'add') void router.navigate('/?add=1&inbox=1');
  else if (m[1] === 'checkin') void router.navigate('/?checkin=1');
  else if (id && m[1] === 'card') {
    void router.navigate('/');
    openCardAnywhere(id);
  } else if (id && m[1] === 'done') completeFromShade(id);
}

export async function installLaunchActions(router: typeof Router): Promise<void> {
  const { App } = await import('@capacitor/app');
  const launch = await App.getLaunchUrl();
  handle(launch?.url, router);
  await App.addListener('appUrlOpen', ({ url }) => handle(url, router));
}
